module.exports = __webpack_public_path__ + "img/58aac6f.svg";